function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function filterRegex(str) {
    const text = str.trim();
    if (!text) {
        return null;
    }
    return new RegExp(`(${escapeRegex(text)})`, 'gi');
}

export { filterRegex }